/*
 * @Author: your name
 * @Date: 2022-08-10 15:44:27
 * @LastEditTime: 2022-11-24 08:54:39
 * @LastEditors: taoyan taoyan_work@163.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \xingmahui_front\src\utils\mockData\moreToolsData.js
 */
export default {
    toolsList: [
        {
            'id': 6,
            'name': '扫码积分',
            'imgSrc': require('../../assets/images/tools/newTools/scanning.png'),
            'link': ''
        },
        {
            'id': 7,
            'name': '产品溯源',
            'imgSrc': require('../../assets/images/tools/newTools/product.png'),
            'link': ''
        },
        {
            'id': 19,
            // 'name': '育儿宝典',
            'name': '奶娃宝典',
            'imgSrc': require('../../assets/images/tools/MoreTools/gj_jkwz.png'),
            'link': '/babyWikipedia'
        },
        // {
        //   'id': 1,
        //   'name': '育儿宝典',
        //   'imgSrc': require('../../assets/images/tools/newTools/book.png'),
        //   'link': '/babyWikipedia'
        // },
        {
            'id': 35,
            'name': '宝宝食谱',
            'imgSrc': require('../../assets/images/tools/newTools/recipes.png'),
            'link': '/babyFeeding'
        },
        // {
        //   'id': 2,
        //   'name': '宝宝食谱',
        //   'imgSrc': require('../../assets/images/tools/newTools/recipes.png'),
        //   'link': '/foodColumn'
        // },
        {
            'id': 3,
            'name': '生长曲线',
            'imgSrc': require('../../assets/images/tools/newTools/grow_bend.png'),
            'link': '/startAssessment' // 参数 num：当前宝宝胎次
        },
        {
            'id': 4,
            'name': '儿歌故事',
            'imgSrc': require('../../assets/images/tools/newTools/music.png'),
            'link': '/babyWikipedia'
        },
        {
            'id': 32,
            'name': '奶粉百科',
            'imgSrc': require('../../assets/images/tools/newTools/powderedMilk.png'),
            'link': ''
        },
        {
            'id': 36,
            'name': '0元试用',
            'imgSrc': require('../../assets/images/tools/newTools/zero_trial.png'),
            'link': ''
        },
        // {
        //   'id': 33,
        //   'name': '营养测评',
        //   'imgSrc': require('../../assets/images/tools/newTools/yytest.png'),
        //   'link': ''
        // },
        {
            'id': 8,
            'name': '疫苗时间表',
            'imgSrc': require('../../assets/images/tools/newTools/vaccines.png'),
            'link': '/remind'  // 参数 num：当前宝宝胎次  bir: 当前宝宝生日
        },
        {
            'id': 9,
            'name': '能不能吃',
            'imgSrc': require('../../assets/images/tools/newTools/can_eat.png'),
            'link': '/canEatList'
        },
        // {
        //   'id': 10,
        //   'name': '备孕宝典',
        //   'imgSrc': require('../../assets/images/tools/newTools/book.png'),
        //   'link': '/babyWikipedia'
        // },
        {
            'id': 11,
            'name': '助眠音乐',
            'imgSrc': require('../../assets/images/tools/newTools/music.png'),
            'link': '/babyWikipedia'
        },
        {
            'id': 12,
            'name': '医生问诊',
            'imgSrc': require('../../assets/images/tools/newTools/doctor.png'),
            'link': ''
        },
        {
            'id': 13,
            'name': '专家问答',
            'imgSrc': require('../../assets/images/tools/newTools/answer.png'),
            'link': '/expertOnline'
        },
        {
            'id': 14,
            'name': '云相册',
            'imgSrc': require('../../assets/images/tools/newTools/baby_photo.png'),
            'link': ''
        },
        // {
        //   'id': 15,
        //   'name': '孕期宝典',
        //   'imgSrc': require('../../assets/images/tools/newTools/book.png'),
        //   'link': '/babyWikipedia'
        // },
        {
            'id': 16,
            'name': '胎教音乐',
            'imgSrc': require('../../assets/images/tools/newTools/music.png'),
            'link': '/babyWikipedia'
        },
        {
            'id': 17,
            'name': '产检提醒',
            'imgSrc': require('../../assets/images/tools/newTools/remind.png'),
            'link': '/remind' // 参数 num：当前宝宝胎次  bir: 当前宝宝生日
        },
        {
            'id': 18,
            'name': '孕期相册',
            'imgSrc': require('../../assets/images/tools/newTools/baby_photo.png'),
            'link': ''
        },

        // {
        //   'id': 20,
        //   'name': '生长曲线',
        //   'imgSrc': require('../../assets/images/tools/newTools/gj_szqx.png'),
        //   'link': '/startAssessment' // 参数 num：当前宝宝胎次
        // },
        {
            'id': 21,
            'name': '喂养记录',
            'imgSrc': require('../../assets/images/tools/newTools/eat_notes.png'),
            'link': '/feedRecord'  // 参数 num：当前宝宝胎次  monthAge：    month：
        },
        {
            'id': 22,
            'name': '哄睡儿歌',
            'imgSrc': require('../../assets/images/tools/newTools/music.png'),
            'link': '/babyWikipedia'
        },
        {
            'id': 23,
            'name': '医生问诊',
            'imgSrc': require('../../assets/images/tools/newTools/doctor.png'),
            'link': ''
        },
        {
            'id': 24,
            'name': '医生问诊',
            'imgSrc': require('../../assets/images/tools/newTools/doctor.png'),
            'link': ''
        },
        {
            'id': 25,
            'name': '营养厨房',
            'imgSrc': require('../../assets/images/tools/newTools/kitchen.png'),
            'link': '/foodColumn'
        },
        {
            'id': 26,
            'name': '营养厨房',
            'imgSrc': require('../../assets/images/tools/newTools/baby_eat.png'),
            'link': '/foodColumn'
        },
        {
            'id': 27,
            'name': '医生问诊',
            'imgSrc': require('../../assets/images/tools/newTools/doctor.png'),
            'link': ''
        },
        {
            'id': 28,
            'name': '育儿问答',
            'imgSrc': require('../../assets/images/tools/newTools/answer.png'),
            'link': '/expertOnline'
        },
        {
            'id': 29,
            'name': '医生问诊',
            'imgSrc': require('../../assets/images/tools/newTools/doctor.png'),
            'link': ''
        },
        {
            'id': 30,
            'name': '星牧场',
            'imgSrc': require('../../assets/images/tools/newTools/star_room.png'),
            'link': ''
        },
        // {
        //     'id': 31,
        //     'name': '扫码盲盒',
        //     'imgSrc': require('../../assets/images/tools/newTools/blindBox.png'),
        //     'link': ''
        // },
        {
            'id': 5,
            'name': '宝宝相册',
            'imgSrc': require('../../assets/images/tools/newTools/baby_photo.png'),

            'link': ''
        },
        {
            'id': 34,
            'name': '辅食测评',
            'imgSrc': require('../../assets/images/tools/newTools/fstest.png'),
            'link': ''
        },

    ]
}
